import React, { useMemo } from 'react';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { LayersIcon } from '@assets/icons/map/Layers';
import { observer } from 'mobx-react';
import { LineContainer, TitleTextStyle } from './UI';
import { LegendItemsCollection } from '@project/store/Legend';
import { LayerLegend, LayerLegendProps } from './LayerLegend';
import { Button } from 'antd';
import { LayerCollection } from '@datum-group/datum-map/lib';
import { BaseLayersStore } from '../../../store/BaseLayersStore';

export type LegendKeys = keyof LegendItemsCollection['legends'];

interface MapLegendProps extends Pick<LayerLegendProps, 'renderCount'> {
  layerCollection: LayerCollection;
  baseLayers: BaseLayersStore;
  onAfterRemoveAllLayers?(): void;
  extra?: JSX.Element;
  isVisible: boolean;
  setIsVisible(value: boolean): void;
  isEmpty?: boolean;
  readonly?: boolean;
}

export const MapLegend: React.FC<MapLegendProps> = observer(
  ({
    layerCollection,
    baseLayers,
    extra,
    onAfterRemoveAllLayers,
    readonly,
    isVisible,
    setIsVisible,
    renderCount,
    isEmpty,
  }) => {
    const legendItems = useMemo(() => {
      return new LegendItemsCollection(layerCollection);
    }, []);

    const handleRemoveAllLayers = () => {
      layerCollection.layers.forEach((layer) => {
        if (baseLayers.getActiveLayer()?.layer_name === layer.name) return;

        layerCollection.remove(layer.name);
      });

      onAfterRemoveAllLayers?.();
    };

    return (
      <div style={{ width: 380, fontFamily: 'Golos UI', fontSize: 14 }}>
        <div
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.88)',
            overflow: 'auto',
            maxHeight: '50vh',
          }}
        >
          {isVisible && (
            <div style={{ paddingBottom: isEmpty ? 0 : '1em' }}>
              {extra}
              {legendItems.legends.map((item) => (
                <LayerLegend
                  key={item[0]}
                  name={item[0]}
                  layer={item[1]}
                  renderCount={renderCount}
                  onRemove={
                    !!readonly
                      ? undefined
                      : layerCollection.remove.bind(layerCollection)
                  }
                />
              ))}
            </div>
          )}
        </div>
        {isVisible && !readonly && !isEmpty && (
          <div
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
            }}
          >
            <Button
              style={{
                width: '100%',
                height: '30px',
              }}
              onClick={handleRemoveAllLayers}
            >
              Очистить все слои
            </Button>
          </div>
        )}
        <div
          style={{
            boxShadow: '0px -4px 12px rgba(20, 43, 79, 0.16)',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            cursor: 'pointer',
          }}
          onClick={() => setIsVisible(!isVisible)}
        >
          <LineContainer
            height={50}
            icon={<LayersIcon />}
            content={<span style={TitleTextStyle}>Слои на карте</span>}
            action={<div>{isVisible ? <DownOutlined /> : <UpOutlined />}</div>}
          />
        </div>
      </div>
    );
  },
);
